import { createSlice } from "@reduxjs/toolkit"

export const profileSlice = createSlice({
    name: "profile",
    initialState: {
        profileDetails: null,
        getOwnDetailsLoading: false,
    },
    reducers: {
        getOwnDetailsLoading: (state) => {
            state.getOwnDetailsLoading = true
        },
        getOwnDetailsSuccess: (state, action) => {
            state.getOwnDetailsLoading = false
            state.profileDetails = action.payload
        },
        getOwnDetailsFailed: (state) => {
            state.getOwnDetailsLoading = false
            state.profileDetails = null
        },
    },
})

export default profileSlice.reducer
export const {
    getOwnDetailsLoading,
    getOwnDetailsSuccess,
    getOwnDetailsFailed,
} = profileSlice.actions
